import axiosInstance from "./axiosConfig";

/**
 * GET request helper
 * @param {string} url - API endpoint
 * @param {object} config - Additional axios config
 * @returns {Promise} - Axios response
 */
export const GetAxios = async (url, config = {}) => {
  try {
    const response = await axiosInstance.get(url, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * POST request helper
 * @param {string} url - API endpoint
 * @param {object} data - Request body
 * @param {object} config - Additional axios config
 * @returns {Promise} - Axios response
 */
export const PostAxios = async (url, data = {}, config = {}) => {
  try {
    const response = await axiosInstance.post(url, data, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * PUT request helper
 * @param {string} url - API endpoint
 * @param {object} data - Request body
 * @param {object} config - Additional axios config
 * @returns {Promise} - Axios response
 */
export const PutAxios = async (url, data = {}, config = {}) => {
  try {
    const response = await axiosInstance.put(url, data, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * PATCH request helper
 * @param {string} url - API endpoint
 * @param {object} data - Request body
 * @param {object} config - Additional axios config
 * @returns {Promise} - Axios response
 */
export const PatchAxios = async (url, data = {}, config = {}) => {
  try {
    const response = await axiosInstance.patch(url, data, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * DELETE request helper
 * @param {string} url - API endpoint
 * @param {object} config - Additional axios config
 * @returns {Promise} - Axios response
 */
export const DeleteAxios = async (url, config = {}) => {
  try {
    const response = await axiosInstance.delete(url, config);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * GET request for blob/binary data (files, PDFs, images, etc.)
 * @param {string} url - API endpoint
 * @param {object} config - Additional axios config
 * @returns {Promise} - Blob data
 */
export const GetBlobAxios = async (url, config = {}) => {
  try {
    const response = await axiosInstance.get(url, {
      ...config,
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
